module.exports = __webpack_public_path__ + "img/motor-retail-failure-v2.9a402395.svg";